import clsx from "clsx";
import { twMerge } from "tailwind-merge";

interface Props<T> {
  value: T;
  options: { value: T; label: string; disabled?: boolean }[];
  disabled?: boolean;
  onChange: (value: T) => void;
}

export const Tabs = <T extends string>({
  value,
  options,
  disabled,
  onChange,
}: Props<T>) => {
  return (
    <div className="text-sm inline-flex gap-4 mb-[-1px]">
      {options.map((option) => {
        return (
          <button
            disabled={disabled ?? option.disabled}
            key={option.value}
            className={twMerge(
              clsx(
                "text-sm text-v2-secondary h-11 px-2 border-y-2 border-transparent",
                {
                  "text-v2-action font-bold border-b-v2-action":
                    option.value === value,
                  "border-b-v2-secondary": option.value === value && disabled,
                  "hover:text-v2-action": !disabled,
                  "text-v2-disabled": disabled,
                },
              ),
            )}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};
